import {BASE_URL} from '@/services/api'
import {METHOD, request} from '@/utils/request'

let PATIENT_LIST= `${BASE_URL}/patient/list`
let PATIENT_DETAIL= `${BASE_URL}/patient/detail`
let PATIENT_MONITOR_LIST= `${BASE_URL}/patient/monitorList`
let SAVE_MONITOR_PHOTO= `${BASE_URL}/patient/saveMonitorPhoto`
let PATIENT_CHOOSE_LIST= `${BASE_URL}/patient/patientChooseList`

export async function GetPatientList() {
  return request(PATIENT_LIST, METHOD.POST)
}

export async function GetPatientDetails(patient_id) {
  return request(PATIENT_DETAIL, METHOD.POST, {
    patient_id:patient_id
  })
}

export async function GetPatientMonitorList(params) {
  return request(PATIENT_MONITOR_LIST, METHOD.POST,params)
}

export async function SaveMonitorPhoto(params) {
  return request(SAVE_MONITOR_PHOTO, METHOD.POST,params,{
    headers: {'Content-Type': 'multipart/form-data'}
  })
}

export async function GetPatientChooseList() {
  return request(PATIENT_CHOOSE_LIST, METHOD.POST)
}



export default {
}
